import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {OverlayModule} from "@angular/cdk/overlay";
import {InputDropdownComponent} from "./input-dropdown.component";
import {InputDropdownOptionComponent} from './input-dropdown-option/input-dropdown-option.component';
import {FilterPipe} from "./filter.pipe";
import {ComboBoxComponent} from "./combo-box/combo-box.component";
import {ValgInputModule} from "../input.module";
import {ValgSharedDirectivesModule} from '@valg-shared/directives/valg-shared-directives.module';
import { CdkScrollableModule } from '@angular/cdk/scrolling';


@NgModule({
    declarations: [
        FilterPipe,
        InputDropdownComponent,
        InputDropdownOptionComponent,
        ComboBoxComponent
    ],
    exports: [
        InputDropdownComponent,
        ComboBoxComponent,
        FilterPipe,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        OverlayModule,
        ValgInputModule,
        ValgSharedDirectivesModule,
        CdkScrollableModule
    ]
})
export class InputDropdownModule {
}
